import { Injectable, computed, signal } from '@angular/core';
import { AuthResponse, AuthSession } from '../models/auth.models';

const STORAGE_KEY = 'duradrive.passenger.session';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly sessionState = signal<AuthSession | null>(this.restore());

  readonly session = this.sessionState.asReadonly();
  readonly isAuthenticated = computed(() => this.sessionState() !== null);

  setSession(response: AuthResponse, email: string): void {
    const session: AuthSession = {
      accessToken: response.accessToken,
      refreshToken: response.refreshToken,
      userId: response.userId,
      userType: response.userType,
      email,
    };
    this.sessionState.set(session);
    this.persist(session);
  }

  logout(): void {
    this.sessionState.set(null);
    if (this.hasStorage()) {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }

  private persist(session: AuthSession): void {
    if (this.hasStorage()) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    }
  }

  private restore(): AuthSession | null {
    if (!this.hasStorage()) {
      return null;
    }
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as AuthSession;
    } catch {
      return null;
    }
  }

  private hasStorage(): boolean {
    return typeof window !== 'undefined' && !!window.localStorage;
  }
}
